<template>
  <li class="list-unstyled" :style="`margin: 5px ${marginRight+9}px 0 0 `" v-if="category.products_count > 0">

    <div class="form-group form-check">
      <input @input="updateValue" :value="category.slug" name="filter_categories" type="radio"
             class="form-check-input" :id="`category_filter_${category.id}`">
      <label class="form-check-label mr-3" :for="`category_filter_${category.id}`">{{ category.name }}</label>
      <b-icon icon="arrow-down-circle" @click="getCategory()" v-if="category.children_count" class="mr-2"></b-icon>

      <category-item @category="$emit('category', item.slug)" :selected-category="selectedCategory" v-for="item in categories" :key="item.id"
                     :margin-right="marginRight+15" :category="item"/>
    </div>

  </li>
</template>

<script>
export default {
  name: "CategoryItem",
  props: ['category', 'marginRight', 'selectedCategory'],
  data() {
    return {
      categories: []
    }
  },
  methods: {
    async getCategory() {
      this.categories = await this.$store.dispatch('Category/getCategoryWithoutState', this.category.slug)
      this.categories = this.categories.data.data.children
    },
    updateValue(event) {
      this.$emit('category', event.target.value)
    },
  },
  model: {
    prop: "selectedCategory",
    event: "input",
  },
}
</script>

<style scoped>

</style>